import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  inject,
} from "@angular/core";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import { ImageToUpload } from "../berichte.component";
import { BerichtImageUploadProgressItemComponent } from "./image/image.component";
import { forkJoin } from "rxjs";

@Component({
  templateUrl: "./upload-progress-popup.component.html",
  styleUrls: ["./upload-progress-popup.component.scss"],
  standalone: false,
})
export class BerichtImageUploadProgressPopupComponent
  extends CstResponsivePopupComponentBase<
    { uploads: ImageToUpload[]; formularID: string },
    boolean
  >
  implements AfterViewInit
{
  private _cfr = inject(ComponentFactoryResolver);
  private _cdr = inject(ChangeDetectorRef);

  @ViewChild("loaderHost", { read: ViewContainerRef })
  loaderHost!: ViewContainerRef;

  ngAfterViewInit(): void {
    const componentFactory = this._cfr.resolveComponentFactory(
      BerichtImageUploadProgressItemComponent,
    );

    const uploadTasks$ = this.data.uploads.map((img) => {
      const componentRef = this.loaderHost.createComponent(componentFactory);
      componentRef.instance.data = img;
      return componentRef.instance._post();
    });

    this._cdr.detectChanges();

    if (uploadTasks$.length > 0) {
      forkJoin(uploadTasks$)
      .subscribe({
        error: () => this.close(false),
        complete: () => this.close(true),
      });
    }
  }
}
